import { ModuleWithProviders, NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { ASYNC_JOB_CONFIG_PROVIDER } from './configs/tokens';
import { AsyncJobEffects } from './store/async-job.effects';

@NgModule({
  imports: [EffectsModule.forFeature([AsyncJobEffects])],
})
export class AsyncJobModule {
  public static forRoot(): ModuleWithProviders<AsyncJobModule> {
    return {
      ngModule: AsyncJobModule,
      providers: [ASYNC_JOB_CONFIG_PROVIDER],
    };
  }
}
